import type { AppState, BackupEnvelope } from '../types'
import { parseBackup, validateBackupEnvelope } from '../domain/validation'

export function createBackupEnvelope(state: AppState): BackupEnvelope {
  return {
    app: 'trevahhh-os',
    version: 2,
    exportedAt: new Date().toISOString(),
    state
  }
}

export function serializeBackup(state: AppState): string {
  return JSON.stringify(createBackupEnvelope(state), null, 2)
}

export function parseAndValidateBackup(raw: string): BackupEnvelope {
  const envelope = parseBackup(raw)
  const issues = validateBackupEnvelope(envelope)
  if (issues.length) throw new Error(issues.join(' '))
  return envelope
}

export function downloadBackup(state: AppState): void {
  const blob = new Blob([serializeBackup(state)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `trevahhh-os-backup-${new Date().toISOString().slice(0, 10)}.json`
  document.body.append(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
